import { httpApi } from '@app/api/http.api';
import { SearchQueryResponse } from '@app/interfaces/interfaces';
import { IRole } from '@app/interfaces/role';
import { QueryRequest } from '@app/store/slices/userSlice';

const baseSlug = '/roles';

export const getRole = async (id: string): Promise<IRole> => {
  try {
    const { data } = await httpApi.get<IRole>(`${baseSlug}/${id}`);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const createRole = async (payload: Partial<IRole>): Promise<IRole> => {
  try {
    const { data } = await httpApi.post<IRole>(`${baseSlug}`, payload);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const updateRole = async (id: string, payload: Partial<IRole>): Promise<IRole> => {
  try {
    const { data } = await httpApi.patch<IRole>(`${baseSlug}/${id}`, payload);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const deleteRole = async (id: string): Promise<undefined> => {
  try {
    const { data } = await httpApi.delete<undefined>(`${baseSlug}/${id}`);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const getRoleListWithPagination = async (queryPayload: QueryRequest): Promise<SearchQueryResponse> => {
  try {
    const { data } = await httpApi.get<SearchQueryResponse>(
      `${baseSlug}/queryRolesWithPagination?${new URLSearchParams(queryPayload as Record<string, string>).toString()}`,
    );
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};
